import { useMemo } from "react";
import { useTokenSeekDashboard } from "@hooks";
import { CRYPTO_THEME_LABELS } from "@/src/componentsv1";

const LIMIT = 10;

/**
 * 填充数组至指定长度
 * @param arr 原始数组
 * @param targetLength 目标长度
 * @returns 填充后的数组
 */
const fillArrayToLength = <T>(arr: T[], targetLength: number): T[] => {
  if (arr.length === 0 || arr.length >= targetLength) {
    return arr.slice(0, targetLength);
  }

  // 计算需要重复的次数
  const repeatCount = Math.ceil(targetLength / arr.length);
  // 使用 Array.from 和 flatMap 一次性创建填充后的数组
  return Array.from({ length: repeatCount })
    .flatMap(() => arr)
    .slice(0, targetLength);
};

export const useListData = () => {
  const { data: blueChipData, isFetching: isFetchingBlueChip } =
    useTokenSeekDashboard({
      sort: "price_change_24h" as any,
      dex_id: CRYPTO_THEME_LABELS.blueChip,
      pageSize: 10,
      source: "home",
    });

  const data = useMemo(() => {
    return fillArrayToLength(blueChipData?.data, LIMIT);
  }, [blueChipData]);

  return {
    data,
    isPending: isFetchingBlueChip,
  };
};
